<template>
  <ul v-show="innerShow" class="custom-dropdown-menu" :style="dropmenuStyle"
    @click.stop="onEventActions" v-click-outside="onClickOutside">
    <!-- <li v-if="options.allowRestoreFile">
      <a href="javascript:;" data-action="restoreFile">
        <span class="cos-icon--16 mr-4 restore"></span>
        <span class="align-middle">{{$t('core.restore')}}</span>
      </a>
    </li> -->
    <li v-if="options.allowDetail">
      <a href="javascript:;" data-action="detail">
        <span class="cos-icon--16 mr-4 detail"></span>
        <span class="align-middle">{{$t('core.detail')}}</span>
      </a>
    </li>
    <li v-if="options.allowPreview">
      <a href="javascript:;" data-action="preview">
        <span class="cos-icon--16 mr-4 preview"></span>
        <span class="align-middle">{{options.previewType==='image'?$t('core.preview'):$t('core.play')}}</span>
      </a>
    </li>
    <!-- <li v-if="options.allowPictureExif">
      <a href="javascript:;" data-action="pictureExif">
        <span class="cos-icon--16 mr-4 info"></span>
        <span class="align-middle">{{$t('core.exif')}}</span>
      </a>
    </li> -->
    <li v-if="options.allowShare">
      <a href="javascript:;" data-action="share">
        <span class="cos-icon--16 mr-4 share"></span>
        <span class="align-middle">{{$t('core.share')}}</span>
      </a>
    </li>
    <!-- <li v-if="options.allowQuickAuth">
      <a href="javascript:;" data-action="quickAuth">
        <span class="cos-icon--16 mr-4 acl"></span>
        <span class="align-middle">{{$t('cos.quick_auth')}}</span>
      </a>
    </li> -->
    <!-- <li v-if="options.allowEditAcl">
      <a href="javascript:;" data-action="editAcl">
        <span class="cos-icon--16 mr-4 acl"></span>
        <span class="align-middle">{{$t('cos.permission_management')}}</span>
      </a>
    </li> -->
    <!-- <li v-if="options.allowManageTag">
      <a href="javascript:;" data-action="manageTag">
        <span class="cos-icon--16 mr-4 version"></span>
        <span class="align-middle">{{$t('cos.tag_management')}}</span>
      </a>
    </li> -->
    <li>
      <a href="javascript:;" data-action="download">
        <span class="cos-icon--16 mr-4 download"></span>
        <span class="align-middle">{{$t('core.download')}}</span>
      </a>
    </li>
    <li v-if="options.allowRename">
      <a href="javascript:;" data-action="rename">
        <span class="cos-icon--16 mr-4 rename"></span>
        <span class="align-middle">{{$t('core.rename')}}</span>
      </a>
    </li>
    <li>
      <a href="javascript:;" data-action="delete">
        <span class="cos-icon--16 mr-4 delete"></span>
        <span class="align-middle">{{$t('core.delete')}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import dropmenuBase from 'src/scripts/mixins/dropmenuBase';

export default {
  mixins: [dropmenuBase],
  props: {
    options: {
      type: Object,
      required: false,
      default: () => ({
        allowDetail: true,
        allowPreview: true,
        allowShare: true,
        allowRename: true,
        // allowPictureExif: true,
      }),
    },
  },
};
</script>

<style scoped lang="scss">
</style>
